/* global axios */
import ApiClient from './ApiClient';

class KanbanTaskGroupsAPI extends ApiClient {
  constructor() {
    super('kanban_task_groups', { accountScoped: true });
  }

  list() {
    return axios.get(this.url);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  destroy(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  apply(id, cardId) {
    return axios.post(`${this.url}/${id}/apply`, { card_id: cardId });
  }
}

export default new KanbanTaskGroupsAPI();
